import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';

import styles from './FilePicker.module.css';

const FilePicker = React.memo(({ isMultiple, children, accept, onSelect }) => {
  const field = useRef(null);

  const handleTriggerClick = useCallback(() => {
    field.current.click();
  }, []);

  const handleFieldChange = useCallback(
    ({ target }) => {
      if (!isMultiple && target.files[0]) {
        onSelect(target.files[0]);
        target.value = null; // eslint-disable-line no-param-reassign
      }
      if (isMultiple && target.files) {
        onSelect(target.files);
        target.value = null; // eslint-disable-line no-param-reassign
      }
    },
    [isMultiple, onSelect],
  );

  const tigger = React.cloneElement(children, {
    onClick: handleTriggerClick,
  });

  return (
    <>
      {tigger}
      <input
        ref={field}
        type="file"
        multiple={isMultiple}
        accept={accept}
        className={styles.field}
        onChange={handleFieldChange}
      />
    </>
  );
});

FilePicker.propTypes = {
  isMultiple: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
  accept: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

FilePicker.defaultProps = {
  accept: undefined,
};

export default FilePicker;
